export enum WebConferenceTypes {
    Webinar = 'webinar',
    Meeting = 'meeting'
}